export default __webpack_public_path__ + "static/media/8_The final lesson.0bb430fe.jpg";